/* tslint:disable */

declare var Object: any;
export interface BillsPaymentsInterface {
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
}

export class BillsPayments implements BillsPaymentsInterface {
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: BillsPaymentsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BillsPayments`.
   */
  public static getModelName() {
    return "BillsPayments";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BillsPayments for dynamic purposes.
  **/
  public static factory(data: BillsPaymentsInterface): BillsPayments{
    return new BillsPayments(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BillsPayments',
      plural: 'BillsPayments',
      path: 'BillsPayments',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
